import { contactsComponents } from "./contacts/navigationComponents";

export const supportComponents = [...contactsComponents];

